import React, { ReactElement } from "react";
import { DefaultValues, FieldValues, FormProvider, SubmitHandler, useForm } from "react-hook-form";

type FormProps<T extends FieldValues> = {
  defaultValues?: DefaultValues<T>;
  children: React.ReactNode;
  onSubmit: SubmitHandler<T>;
  className?: string;
};

const Form = <T extends FieldValues>({ defaultValues, children, onSubmit, className }: FormProps<T>) => {
  const methods = useForm<T>({ defaultValues });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className={className}>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child) && child.props.name) {
            return React.cloneElement(child as ReactElement, {
              key: child.props.name,
            });
          }
          return child;
        })}
      </form>
    </FormProvider>
  );
};

export default Form;
